import { useVIPStatus } from '@hooks/useVIPStatus';

function VIPMessage() {
    const { isVIP } = useVIPStatus();

    if (!isVIP) return null;

    return (
        <section id="vipMessage" className="vip-message" style={{ display: 'block' }}>
            <div className="vip-content">
                <div className="vip-icon">👑</div>
                <div className="vip-text">
                    <h3>Member VIP Eksklusif</h3>
                    <p>Pengalaman premium tanpa iklan</p>
                </div>
                <div className="vip-badge">VIP</div>
            </div>
        </section>
    );
}

export default VIPMessage;
